
$(document).ready(function () {
   $(".category-dropdown").click(function(){
            $(".category-dropdown").toggleClass('show');
            $('ul.sub-menu').removeClass('show');
            $('a.indicator').removeClass('rotate');
        });
        $(".category-menu a:nth-child(2)").click(function(){
            $('ul.sub-menu').removeClass('show');
            $('a.indicator').removeClass('rotate');
            $(this).siblings('ul.sub-menu').addClass('show');
            $(this).addClass('rotate');
        });
        $(document).mouseup(function(e) {
          var mainmenu = $(".header-select");
          if (!mainmenu.is(e.target) && mainmenu.has(e.target).length === 0) {        
            $(".category-dropdown").removeClass("show");
          }
        });
        $(document).on('keydown', function(event) {
          if (event.key == "Escape") {
            $(".category-dropdown").removeClass('show');
          }
        });
  $(".home-main-slider-wrap").slick({
    arrows: false,
    dots: true,
  });
  $(".home-categories-slider-wrap").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    dots: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".home-brands-slider-wrap").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    asNavFor: ".product-thumbnail-slider",
  });
  $(".product-thumbnail-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".product-slider",
    focusOnSelect: true,
    arrows: false,
  });
  $(".header-navigation-toggle-btn").on("click", function () {
    $(".header-navigation").toggleClass("active");
  });
  $(".product-quantity-input").on("keypress keyup blur", function (e) {
    $(this).val(
      $(this)
        .val()
        .replace(/[^\d].+/, "")
    );
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  });
  $(".product-quantity-plus").click(function () {
    var currentValue = $(".product-quantity-input").val();
    currentValue = parseInt(currentValue) + 1;
    $(".product-quantity-input").val(currentValue);
  });
  $(".product-quantity-minus").click(function () {
    var currentValue = $(".product-quantity-input").val();
    if (currentValue > 1) {
      currentValue = parseInt(currentValue) - 1;
      $(".product-quantity-input").val(currentValue);
    }
  });
  $(".product-listing-filter-toggle-btn").on("click", function () {
    $(".product-listing-filter-all").addClass("active");
    return false;
  });
  $("html").on("click", function () {
    $(".product-listing-filter-all").removeClass("active");
  });
  $(".product-listing-filter-all").on("click", function (e) {
    e.stopPropagation();
  });
   if ($(window).width() > 768) {
    $(".product-slide").zoom();
  }
});



// match height

// $(function ($) {  
// $(window).on('load',function() {
// equalheight('.product-sm-image');
// equalheight('.home-categories-slide-image');
// equalheight('.product-sm-content h6');  

// });
 
// $(window).on('resize',function() {
// equalheight('.product-sm-image');
// equalheight('.home-categories-slide-image');
// equalheight('.product-sm-content h6');  
// });  
  
// });


